import {
  FileButtonProps as MantineFileButtonProps,
  FileButton as MantineFileButton,
} from '@mantine/core';

export type FileButtonProps = MantineFileButtonProps;

export const FileButton = MantineFileButton as typeof MantineFileButton;

FileButton.displayName = 'FileButton';
